import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { extractFirmwareVersionFromFirmwarePackageFilename, listFirmwarePackages } from 'motion-master-client';
import { map, switchMap } from 'rxjs/operators';

import { loadFirmwaresRequest, loadFirmwaresSuccess, updateFirmwaresLoading } from './firmware.actions';
import { Firmware } from './firmware.model';

import { BrandService } from '@app/services/brand.service';

@Injectable()
export class FirmwareEffects {
  private actions$ = inject(Actions);
  private brandService = inject(BrandService);

  updateFirmwaresLoadingOnLoadFirmwaresRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFirmwaresRequest),
      map(() => updateFirmwaresLoading({ firmwaresLoading: true })),
    ),
  );

  handleLoadFirmwaresRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFirmwaresRequest),
      switchMap(() => {
        const brandId = this.brandService.brand?.id;
        return listFirmwarePackages(brandId);
      }),
      map((filenames: string[]) => {
        const firmwares = filenames
          .map((packageFilename) => {
            let version: string;
            try {
              version = extractFirmwareVersionFromFirmwarePackageFilename(packageFilename);
            } catch (err) {
              console.error(err);
            }
            return { packageFilename, version } as Firmware;
          })
          .filter((firmware) => firmware.version);
        return loadFirmwaresSuccess({ firmwares });
      }),
    ),
  );

  updateFirmwaresLoadingOnLoadFirmwaresComplete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadFirmwaresSuccess),
      map(() => updateFirmwaresLoading({ firmwaresLoading: false })),
    ),
  );
}
